// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BAMW","left":"styles_left__25HaF"};